import PropTypes from 'prop-types';
import CheckBoxField from '../../../Form/CheckBoxField/CheckBoxField';
import { get, indexOf } from 'lodash';
import classNames from 'classnames';
import highlightTerm from './highlightTerm';

const FilterOption = ({
  option,
  onChange,
  activeFilters = [],
  searchTerm = '',
  uniqIdPrefix = '',
  disableParentSelect = false,
}) => {
  const label = searchTerm ? highlightTerm(option.label, searchTerm) : option.label;
  const id = `${uniqIdPrefix}${option.value}`;

  const filterOptionClass = () => classNames({
    'h-full font-regular-font': true,
  });

  const parentOptionClass = () => classNames({
    'px-3 h-10 place-content-center': true,
    'border-l-4 border-transparent': true,
    'hover:border-action-blue hover:bg-medium-fill-blue': true,
  });

  const childOptionClass = () => classNames(`${id}__child`, {
    'px-6 h-10 place-content-center border-l-4 border-transparent': true,
    'hover:border-action-blue hover:bg-medium-fill-blue': true,
  });

  const onMouseEnter = () => {
    const children = Array.from(document.getElementsByClassName(`${id}__child`));
    children.map((child) => {
      child.style.background = '#ECF5FD';
      child.style.borderLeft = '4px solid #4467AB';
    });
  };

  const onMouseLeave = () => {
    const children = Array.from(document.getElementsByClassName(`${id}__child`));
    children.map((child) => {
      child.style.background = '';
      child.style.borderLeft = '';
    });
  };

  if (get(option, 'hasChildren', false)) {
    return (
      <div className={filterOptionClass()}>
        <div className={parentOptionClass()} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
          {disableParentSelect ? (
            <span className="text-sm font-semibold">{label}</span>
          ) : (
            <CheckBoxField
              data-testid={disableParentSelect ? null : "filter-option"}
              id={id}
              label={label}
              value={indexOf(activeFilters, option.value) >= 0}
              onChange={e => onChange(option, e.target.value)}
              style={{
                label: 'uppercase font-semibold',
              }}
            />
          )}
        </div>
        {
          get(option, 'children', []).map((child) => (
            <div
              data-testid="filter-option"
              className={childOptionClass()}
              aria-label={child.label}
              tabIndex={0}
              key={`${id}__${child.value}`}
            >
              <CheckBoxField
                id={`${id}__${child.value}`}
                label={searchTerm ? highlightTerm(child.label, searchTerm) : child.label}
                value={indexOf(activeFilters, child.value) >= 0}
                onChange={e => onChange(child, e.target.value)}
              />
            </div>
          ))
        }
      </div>
    );
  }

  return (
    <div data-testid="filter-option" className={filterOptionClass()} aria-label={label} tabIndex={0}>
      <div className={parentOptionClass()}>
        <CheckBoxField
          id={id}
          label={label}
          value={indexOf(activeFilters, option.value) >= 0}
          onChange={e => onChange(option, e.target.value)}
          style={{
            label: 'capitalize',
          }}
        />
      </div>
    </div>
  );
};

FilterOption.propTypes = {
  activeFilters: PropTypes.array,
  option: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  uniqIdPrefix: PropTypes.string,
  disableParentSelect: PropTypes.bool,
};

export default FilterOption;
